import LiveChat from '../../components/types/brandlive-event';
import { GetInvitationsForPresenter } from '../../connection/app-entry';
import { LoadSessions } from '../../connection/showrooms';
import { LoadMeetingsEventsLegacyProducer, LoadMeetingsEventsProducer, LoadMeetingsStandaloneGreenroomProducer } from '../../connection/meeting';
import { GetDefaultBackgrounds, GetVirtualBgs } from '../../connection/media';
import { VirtualBg } from '../types/content';

export const SET_EVENT = 'SET_EVENT';
interface Action {
	type: string;
	payload: any;
}

export function setEvent(event: LiveChat): Action {
	return {
		type: SET_EVENT,
		payload: event,
	};
}

interface AsyncAction {
	type: string;
	promise: Promise<any>
}

export const LOAD_MEETINGS_EVENTS_PRODUCER = 'LOAD_MEETINGS_EVENTS_PRODUCER';
export function loadMeetingsEventsProducer(token: string, channel: number): AsyncAction {
	return {
		type: LOAD_MEETINGS_EVENTS_PRODUCER,
		promise: LoadMeetingsEventsProducer(token, channel),
	};
}

export const LOAD_MEETINGS_EVENTS_LEGACY_PRODUCER = 'LOAD_MEETINGS_EVENTS_LEGACY_PRODUCER';
export function loadMeetingsEventsLegacyProducer(token: string): AsyncAction {
	return {
		type: LOAD_MEETINGS_EVENTS_LEGACY_PRODUCER,
		promise: LoadMeetingsEventsLegacyProducer(token),
	};
}

export const LOAD_MEETINGS_SHOWROOMS_PRODUCER = 'LOAD_MEETINGS_SHOWROOMS_PRODUCER';
export function loadMeetingsShowroomsProducer(accessToken: string): AsyncAction {
	return {
		type: LOAD_MEETINGS_SHOWROOMS_PRODUCER,
		promise: LoadSessions(accessToken),
	};
}

export const LOAD_MEETINGS_STANDALONE_GREENROOM_PRODUCER = 'LOAD_MEETINGS_STANDALONE_GREENROOM_PRODUCER';
export function loadMeetingsStandaloneGreenroomProducer(token: string): AsyncAction {
	return {
		type: LOAD_MEETINGS_STANDALONE_GREENROOM_PRODUCER,
		promise: LoadMeetingsStandaloneGreenroomProducer(token),
	};
}

export const LOAD_MEETINGS_PRESENTER = 'LOAD_MEETINGS_PRESENTER';
export function loadMeetingsPresenter(token: string): AsyncAction {
	return {
		type: LOAD_MEETINGS_PRESENTER,
		promise: GetInvitationsForPresenter(token),
	};
}

export const SET_LIVE_CHANNELS = 'SET_LIVE_CHANNELS';
export function setLiveChannels(channels: any): Action {
	return {
		type: SET_LIVE_CHANNELS,
		payload: channels,
	};
}

export const UPDATE_EVENTS_PRESENTER = 'UPDATE_EVENTS_PRESENTER';
export function updateMeetingsPresenter(events: any): Action {
	return {
		type: UPDATE_EVENTS_PRESENTER,
		payload: events,
	};
}

export const GET_DEFAULT_BACKGROUNDS = 'GET_DEFAULT_BACKGROUNDS';
export function getDefaultBackgrounds(token: string): AsyncAction {
	return {
		type: GET_DEFAULT_BACKGROUNDS,
		promise: GetDefaultBackgrounds(token),
	};
}

export const LOAD_VBGS = 'LOAD_VBGS';
export function loadVBGs(token: string, userId: number, initialPayload?: string): AsyncAction {
	return {
		type: LOAD_VBGS,
		promise: GetVirtualBgs(token, userId),
		meta: { initialPayload },
	} as AsyncAction;
}

export const SELECT_VBG = 'SELECT_VBG';
export function selectVBG(bg: VirtualBg | null): Action {
	return {
		type: SELECT_VBG,
		payload: bg,
	};
}

export const ADD_UPLOADING_VBG = 'ADD_UPLOADING_VBG';
export function addUploadingVBG(payload: string): Action {
	return {
		type: ADD_UPLOADING_VBG,
		payload,
	};
}

export const REMOVE_UPLOADING_VBG = 'REMOVE_UPLOADING_VBG';
export function removeUploadingVBG(payload: string): Action {
	return {
		type: REMOVE_UPLOADING_VBG,
		payload,
	};
}
